module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/weight-1-eaf58080d1a8426152f90f4698a98b21.svg";